import React from "react";
import { ContactUsUI } from "components";

const ContactUs = () => {
  return (
    <>
      <ContactUsUI />
    </>
  );
};

export { ContactUs };
